export default __webpack_public_path__ + "static/rainbow@2x-a12dac0a47b1733ebecdc247d282427a.png";